import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'global';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { getBrand } from './environments/brand';

if (environment.production) {
  enableProdMode();
}

const brand = getBrand();

// Pick favicon and page title from the brand matching the current URL
const faviconLink: HTMLLinkElement = document.querySelector("link[rel='icon']") || document.head.appendChild(document.createElement('link'));
faviconLink.rel = 'icon';
faviconLink.type = 'image/x-icon';
faviconLink.href = brand.favicon;
document.title = brand.title;

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
